import createIcon from '../../createIcon';

/**
 * @component @name Light
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgNi4wNlYzSDExVjYuMDZDNi41IDYuNTYgMyAxMC4zNyAzIDE0Ljk5QzMgMTYuMSAzLjkgMTcgNS4wMSAxN0g4QzggMTkuMjEgOS43OSAyMSAxMiAyMUMxNC4yMSAyMSAxNiAxOS4yMSAxNiAxN0gxOC45OUMyMC4xIDE3IDIxIDE2LjEgMjEgMTQuOTlDMjEgMTAuMzcgMTcuNSA2LjU2IDEzIDYuMDZaTTUgMTVDNSAxMS4xNCA4LjE0IDggMTIgOEMxNS44NiA4IDE5IDExLjE0IDE5IDE1SDVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Light = createIcon('Light', [
  [
    'path',
    {
      d: 'M13 6.06V3H11V6.06C6.5 6.56 3 10.37 3 14.99C3 16.1 3.9 17 5.01 17H8C8 19.21 9.79 21 12 21C14.21 21 16 19.21 16 17H18.99C20.1 17 21 16.1 21 14.99C21 10.37 17.5 6.56 13 6.06ZM5 15C5 11.14 8.14 8 12 8C15.86 8 19 11.14 19 15H5Z',
      key: '7zg62t',
    },
  ],
]);

export default Light;
